import axios from 'axios';
import { config } from '../../config';

const read_dif_code = (value = '') => {
    const difCode = `${value || ''}`.trim().toUpperCase();

    return /^DIF-\d{4,}$/.test(difCode) ? difCode : '';
};

const search_clients = (searchValue) => {
    const difCode = read_dif_code(searchValue);

    if (!difCode) {
        return Promise.resolve([]);
    }

    return axios.get(`${config.backendUrl}/agency/clients`, {
        params: {
            search: difCode,
            limit: 8
        }
    }).then((response) => {
        const clients = Array.isArray(response?.data?.data) ? response.data.data : [];

        return clients.filter((client) => {
            return client?.client === true && read_dif_code(client?.difCode) === difCode;
        });
    });
};

export {
    search_clients
};
